// Privacy-first local cache of orders this device placed.
// Each entry contains the order id AND a signed view_token issued by the backend
// at order creation. Without a valid view_token the customer endpoint returns
// only redacted data — so even if another customer guesses an order ID they
// cannot see name / phone / address.

const KEY = 'graamcart_order_history'; // kept stable to preserve existing carts after rebrand
const MAX = 50;

export function readOrderHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { entries: [], phone: '' };
    const parsed = JSON.parse(raw);

    // Migration: old shape was { ids: ["uuid", ...] } — convert to entries without tokens.
    // Those orders will only display redacted data until customer reorders.
    if (Array.isArray(parsed.ids) && !Array.isArray(parsed.entries)) {
      const entries = parsed.ids.map((id) => ({ id, token: null }));
      return { entries, phone: parsed.phone || '' };
    }
    return {
      entries: Array.isArray(parsed.entries) ? parsed.entries : [],
      phone: typeof parsed.phone === 'string' ? parsed.phone : '',
    };
  } catch {
    return { entries: [], phone: '' };
  }
}

export function pushOrderToHistory(orderId, token, phone) {
  const cur = readOrderHistory();
  const without = cur.entries.filter((e) => e.id !== orderId);
  const entries = [{ id: orderId, token: token || null }, ...without].slice(0, MAX);
  const next = { entries, phone: phone || cur.phone };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function getTokenForOrder(orderId) {
  const cur = readOrderHistory();
  return cur.entries.find((e) => e.id === orderId)?.token || null;
}

export function clearOrderHistory() {
  localStorage.removeItem(KEY);
}
